import React, { Component } from 'react';
import {NavLink} from 'react-router-dom'
import * as func from "../../../../../utils/functions";
import {BASE_PATH, MESSAGE, EDIT_MODE, STATUS_NAME} from "../../../../../wpconfig"
import EditInput from "../../../../etc/admin/input";

class Item extends Component {
  constructor(props) {
    super(props);

		const r = JSON.parse(JSON.stringify(this.props.record));

		this.state = {
			isEdit: r.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record : r,
			field : 'author',
			dept_depth1 : [],
			dept_depth2 : [],
			dept_depth3 : [],
			autoSearchFocus : '',
			autoSearchRecords : [],
		}

		this.setInfo = this.setInfo.bind(this)
  }

  componentDidMount() {
		this.setDepth()
  }

	setDepth() {
		let depth1 = [];
		let depth2 = [];
		let depth3 = [];

		if (this.props.dept.length > 0) {
			depth1 = this.getChildDepth(0)

			if (this.props.record.col_id) { depth2 = this.getChildDepth(this.props.record.col_id) }
			if (this.props.record.dept_id) { depth3 = this.getChildDepth(this.props.record.dept_id) }
	
			this.setState({
				dept_depth1 : depth1,
				dept_depth2 : depth2,
				dept_depth3 : depth3
			})
		}
	}

	getChildDepth(parent_id) {
		let returnData = this.props.dept.filter(f => f.up_category_id == parent_id);
		return returnData
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}

    const { record } = this.props
		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (record.author_id) {
				record.maj_id = record.maj_id ? record.maj_id : 0
				// console.log(record)
				func.updateData("admin/resource/"+func.getParams("record_id")+"/author/update", record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({
							record : JSON.parse(JSON.stringify(record))
						})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				if (this.author_name.value === '') {
					this.author_name.focus();
				} else {
					delete record.is_edit;
					func.updateData("admin/resource/"+func.getParams("record_id")+"/author/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.setState({'isEdit': isEdit});
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	}

	onCloseDelete = (event) => {
		event.preventDefault()
		if (this.props.record.author_id) {
			if (this.state.isEdit) {
				Object.keys(this.state.record).map((key) => {
					if(this[key]) {
						this[key].value = this.state.record[key]
					}
				});
				this.props.onUpdate(this.props.arrIndex, this.state.record, true);
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm('저자 ' + this.props.record.author_name + '을(를) ' + MESSAGE.DELETE)) {
					func.updateData("admin/resource/"+func.getParams("record_id")+"/author/delete", this.props.record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record.author_id) {
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	}

  onChange = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, false);
  }

	onChangeCountry = (event) => {
		let record = this.props.record;
		record['country'] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, true);
	}

	onKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			this.search()
		}
	}

	textEvent = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		if ( event.target.name === 'self_confirm' || event.target.name === 'mou') {
			if(!event.target.checked) {
				record[event.target.name] = ''
			}
		} else if(event.target.name === 'sinbun_code') {
			this.props.sinbun_type.map((type, i) => {
				if( event.target.value == type.code_id) {
					record['sinbun_name'] = type.code_name
				}
			})
		}
		this.props.onUpdate(this.props.arrIndex, record, true);
	}

	autoSearchText = (event) => {
		let record = this.props.record;
    let el = event.target.name;
		let keyword = event.target.value;
		let autoRecords;

		record[el] = keyword;

		switch(el){
			case "col_name":
				record.dept_id = "";
				record.maj_id = "";
				// autoRecords = this.state.dept_depth1.filter(f => f.name.includes(keyword));
				autoRecords = this.state.dept_depth1.filter(f => new RegExp(keyword, 'i').test(f.category_name));
				break;
			case "dept_name":
				record.maj_id = "";
				autoRecords = this.state.dept_depth2.filter(f => new RegExp(keyword, 'i').test(f.category_name));
				break;
			case "maj_name":
				autoRecords = this.state.dept_depth3.filter(f => new RegExp(keyword, 'i').test(f.category_name));
				break;
		}

    this.setDepth();

		this.setState({
			autoSearchFocus: el,
			autoSearchRecords: autoRecords
		})

		this.props.onUpdate(this.props.arrIndex, record, false);
	}

	autoSearchFocus = (event) => {
		this.setState({
			autoSearchFocus : '',
			autoSearchRecords: []
		})
	}

	setInfo (type, item) {
		let record = this.props.record;
		if(type === 'col') {
			record.col_id = item.category_id;
			record.col_name = item.category_name;
			record.dept_id = '';
			record.dept_name = '';
			record.maj_id = '';
			record.maj_name = '';
		} else if(type === 'dept') {
			record.dept_id = item.category_id;
			record.dept_name = item.category_name;
			record.maj_id = '';
			record.maj_name = '';
		} else if(type === 'maj') {
			record.maj_id = item.category_id;
			record.maj_name = item.category_name;
		}

    this.setDepth();

		this.props.onUpdate(this.props.arrIndex, record, false);

		this.setState({
			autoSearchFocus : '',
			autoSearchRecords: [],
		})
	}

	AuthorPopup = (event) => {
		this.props.setAuthorPopup(true, this.props.arrIndex, this.props.record.author_name)
	}

	AuthorityPopup = (event) => {
		this.props.setAuthorityPopup(true, this.props.arrIndex, this.props.record.org_name)
	}
	
	unChainScholar = (event) => {
		if (confirm("저자 연결을 해지하시겠습니까?")) {
			let r = this.props.record;
			r.author_name = r.author_full_name ? r.author_full_name : r.author_name;
			r.school_no = ''
			r.sinbun_code = ''
			r.scholar_id = 0;
			r.col_name = ''
			r.col_id = ''
			r.dept_name =''
			r.dept_id = ''
			r.maj_name = ''
			r.maj_id = ''
			r.email = ''
			this.props.setAuthor(r, this.props.arrIndex);
		}
	}

  render() {
    const { textEvent, autoSearchText, autoSearchFocus } = this
    const { record } = this.props

    return (
			<>
				{
          this.state.isEdit === EDIT_MODE.SHOW ?
			  <tr className="list-row">
				  <td scope="row">
					  <input type="checkbox" className="mt-2 ml-0"
					         value={record.author_id}
					         checked={this.props.checked}
					         onChange={this.props.onRecordCheck} />
				  </td>
				  <td>
					  <label className="m-0">{ record.author_order }</label>
				  </td>
				  <td>
					  <p className="m-0"><label className="m-0 font-weight-bold">{ record.author_name || "" }</label>
						{ record.scholar_id ? (
							<a href="#" onClick={() => window.open("admin.php?page=scholar&record_id=" + this.props.record.scholar_id, '_blank')}>
								<span className="ml-1 link-icon align-middle" />
							</a>
						) : "" }
					  </p>
					  { record.school_no ? (<p className="m-0">{ record.school_no || "" }</p>) : "" }
				  </td>
				  <td>
					  <label className="m-0">{ this.props.sinbun_type_Name[record.sinbun_code] || "" }</label>
				  </td>
				  <td>
					  <label className="m-0">{ this.props.author_role_Name[record.author_role] || "" }</label>
				  </td>
				  <td>
					  <label className={"m-0" + (record.org_id ? ' btn-outline-success' : '')} onClick={()=>this.props.onAuthorBulkChangeOrg(record)}>{ record.org_name || "" }</label>
				  </td>
				  <td>
					  { record.col_name ? (<label className="m-0 pr-2">{ record.col_name || "" }</label>) : "" }
					  { record.dept_name ? (<label className="m-0 font-weight-bold pr-2">{ record.dept_name || "" }</label>) : "" }
					  { record.maj_name ? (<label className="m-0">{ record.maj_name || "" }</label>) : "" }
				  </td>
				  <td>
					  <label className="m-0">{ record.country || "" }</label>
				  </td>
				  <td>
					  <label className="m-0">{ record.email || "" }</label>
				  </td>
				  <td>
					  <label className="m-0">
						  {!record.author_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
							  : record.author_status === 'publish' ? <span className="badge badge-item-status badge-success">{STATUS_NAME[record.author_status]}</span>
								  : record.author_status === 'draft' ? <span className="badge badge-item-status badge-warning">{STATUS_NAME[record.author_status]}</span>
									  : record.author_status === 'trash' ? <span className="badge badge-item-status badge-dark">{STATUS_NAME[record.author_status]}</span>
										  : record.author_status === 'unpublish' ? <span className="badge badge-item-status badge-secondary">{STATUS_NAME[record.author_status]}</span>
											  : ''
						  }
					  </label>
				  </td>
				  <td className="column-action">
					  <div className="btn-group">
						  <button className="btn btn-outline-success btn-sm insert" onClick={this.onEditSave}>편집</button>
						  {
							  record.author_status === 'trash' ? <button className="btn btn-outline-danger btn-sm cancel" onClick={this.onCloseDelete}>삭제</button> : ''
						  }
					  </div>
				  </td>
			  </tr>
			  :
			  <tr>
					<td colSpan="11" className="edit-row">
						<div className="p-1">
							<h6>저자 {record.author_id ? '수정' : '추가'}</h6>
							<div className="row mb-2">
								<div className="col-md-3">
									<div className="form-group">
										<label><strong>소속(기관)</strong></label>
										<div className="input-group">
											<input
												type="text"
												name="org_name"
												className="form-control"
												ref={(ref) => this.org_name = ref}
												value={record.org_name || ""}
												onChange={textEvent}
												onKeyDown={this.onKeyDown}
											/>
											<div className="input-group-prepend">
												<div className="input-group-text search-authority"><span className="search-icon" onClick={this.AuthorityPopup}></span></div>
											</div>
											{record.org_id ? (
													<>
														<div className="icon-flex-center">
															<a href="#" onClick={() => window.open("https://lib.pusan.ac.kr/scholar/wp-admin/admin.php?page=researchmind-authority&record_id=" + this.props.record.org_id, '_blank')}>
																<span className="ml-1 link-icon align-middle"/>
															</a>
														</div>
													</>
												) :
												""}
										</div>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>단대</strong></label>
										<div className="input-group">
											<input
												type="text"
												name="col_name"
												className="form-control"
												ref={(ref) => this.col_name = ref}
												value={record.col_name || ""}
												onFocus={autoSearchText}
												onChange={autoSearchText}
												onKeyDown={this.onKeyDown}
											/>
											{this.state.autoSearchFocus === 'col_name' &&
												<div className="auto-search-dropdown">
													{this.state.autoSearchRecords.length < 1 && (<label>단대 목록이 없습니다.</label>)}
													{this.state.autoSearchRecords.map((item, index) => {
														return (<label key={index} onClick={() => this.setInfo('col', item)}>{item.category_name}</label>)
													})}
												</div>
											}
										</div>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>학과</strong></label>
										<div className="input-group">
											<input
												type="text"
												name="dept_name"
												className="form-control"
												ref={(ref) => this.dept_name = ref}
												value={record.dept_name || ""}
												onFocus={autoSearchText}
												onChange={autoSearchText}
												onKeyDown={this.onKeyDown}
											/>
											{this.state.autoSearchFocus === 'dept_name' &&
												<div className="auto-search-dropdown">
													{this.state.autoSearchRecords.length < 1 && (<label>하위 학과가 없습니다.</label>)}
													{this.state.autoSearchRecords.map((item, index) => {
														return (<label key={index} onClick={() => this.setInfo('dept', item)}>{item.category_name}</label>)
													})}
												</div>
											}
										</div>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>전공</strong></label>
										<div className="input-group">
											<input
												type="text"
												name="maj_name"
												className="form-control"
												ref={(ref) => this.maj_name = ref}
												value={record.maj_name || ""}
												onFocus={autoSearchText}
												onChange={autoSearchText}
												onKeyDown={this.onKeyDown}
											/>
											{this.state.autoSearchFocus === 'maj_name' &&
												<div className="auto-search-dropdown">
													{this.state.autoSearchRecords.length < 1 && (<label>하위 전공이 없습니다.</label>)}
													{this.state.autoSearchRecords.map((item, index) => {
														return (<label key={index} onClick={() => this.setInfo('maj', item)}>{item.category_name}</label>)
													})}
												</div>
											}
										</div>
									</div>
								</div>
								<div className="col-md-1">
									<div className="form-group">
										<label><strong>MOU확인</strong></label>
										<input
											name="mou"
											type="checkbox" value="Y" checked={record.mou === 'Y'} onChange={textEvent}
											style={{'display': 'block', marginTop: '1%'}}
										/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>MOU코드</strong></label>
										<div className="input-group">
											<input
												type="text"
												name="mou_code"
												className="form-control"
												ref={(ref) => this.mou_code = ref}
												value={record.mou_code || ""}
												onChange={textEvent}
												onKeyDown={this.onKeyDown}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="row mb-2">
								<div className="col-md-3">
									<div className="form-group">
										<label><strong>저자</strong></label>
										<div className="input-group">
											<input
												type="text"
												name="author_name"
												className="form-control"
												ref={(ref) => this.author_name = ref}
												value={record.author_name || ""}
												onChange={textEvent}
												onKeyDown={this.onKeyDown}
											/>
											<div className="input-group-prepend">
												<div className="input-group-text search-scholar"><span className="search-icon" onClick={this.AuthorPopup}></span></div>
											</div>
											{record.scholar_id ? (
													<>
														<div className="icon-flex-center">
															<a href="#" onClick={() => window.open("admin.php?page=scholar&record_id=" + this.props.record.scholar_id, '_blank')}>
																<span className="ml-1 link-icon align-middle"></span>
														</a>
														<span className="ml-1 unlink-icon" onClick={this.unChainScholar}></span>
													</div>
												</>
												) :
											""}
										</div>
									</div>
								</div>
								<div className="col-md-3">
									<div className="form-group">
										<label>저자 약어</label>
										<input type="text" name="author_abbr_name" className="form-control readonly" readOnly={true}
										       value={record.author_abbr_name || ""}/>
									</div>
								</div>
								<div className="col-md-3">
									<div className="form-group">
										<label>저자 풀네임</label>
										<input type="text" name="author_full_name" className="form-control readonly" readOnly={true}
										       value={record.author_full_name || ""}/>
									</div>
								</div>
								<div className="col-md-3">
									<div className="form-group">
										<label><strong>국가</strong></label>
										<div className="row">
											<div className="col pr-0">
												<select className="form-control form-control-sm"
														defaultValue={record.country || ""}
														onChange={this.onChangeCountry}>
													<option value="">선택해주세요.</option>
													{this.props.country.map((type, i) => {
														return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
													})}
												</select>
											</div>
											<div className="col">
												<input type="text" name="country" className="form-control readonly" readOnly={true} value={record.country || ""}
													   onChange={textEvent}/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row mb-2">
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>교번</strong></label>
										<input
											type="text"
											name="school_no"
											className="form-control"
											ref={(ref)=>this.school_no=ref}
											value={record.school_no || ""}
											onChange={textEvent}
											onKeyDown={this.onKeyDown}
										/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>신분</strong></label>
										<select className="form-control form-control-sm"
												value={record.sinbun_code || ""}
												ref={(ref)=>this.sinbun_code=ref}
												name="sinbun_code"
												onChange={textEvent}>
											<option value="">선택해주세요.</option>
											{this.props.sinbun_type.map((type, i) => {
												return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
											})}
										</select>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>메일</strong></label>
										<input
											type="text"
											name="email"
											className="form-control"
											ref={(ref)=>this.email=ref}
											value={record.email || ""}
											onChange={textEvent}
											onKeyDown={this.onKeyDown}
										/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>역할</strong></label>
										<select className="form-control form-control-sm"
												defaultValue={record.author_role}
												ref={(ref)=>this.author_role=ref}
												name="author_role"
												onChange={textEvent}>
											<option value="">선택해주세요.</option>
											{this.props.author_role.map((type, i) => {
												return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
											})}
										</select>
									</div>
								</div>
								<div className="col-md-1">
									<div className="form-group">
										<label><strong>순서</strong></label>
										<input
											type="text"
											name="author_order"
											className="form-control"
											ref={(ref)=>this.author_order=ref}
											value={record.author_order || ""}
											onChange={textEvent}
											onKeyDown={this.onKeyDown}
										/>
									</div>
								</div>
								<div className="col-md-1">
									<div className="form-group">
										<label><strong>본인확인</strong></label>
										<input
											name="self_confirm"
											type="checkbox" value="Y" checked={record.self_confirm === 'Y'} onChange={textEvent}
											style={{'display' : 'block', marginTop : '1%'}}
										/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<label><strong>상태</strong></label>
										<select className="form-control form-control-sm"
												defaultValue={record.author_status}
												ref={(ref)=>this.author_status=ref}
												name="author_status"
												onChange={textEvent}>
											<option value="publish">{STATUS_NAME["publish"]}</option>
											<option value="draft">{STATUS_NAME["draft"]}</option>
											<option value="trash">{STATUS_NAME["trash"]}</option>
											<option value="unpublish">{STATUS_NAME["unpublish"]}</option>
										</select>
									</div>
								</div>
							</div>

							<div className="row mb-2">
								<div className="col-md-10">
									<p className="mb-0">
										{record.researcher_id ? "Researcher ID : " + record.researcher_id :''}
										{record.scopus_id ? " Scopus ID : " + record.scopus_id :''}
										{record.kci_id ? " KCI ID : " + record.kci_id :''}
										{record.orcid ? " ORCID : " + record.orcid :''}
										<span className="pl-2">임시저장에서 완료 변경시 Scholar 연구자ID에 자동 입력, 완료 처리된 연구자 변경시 수동 삭제 필요</span>
									</p>
									{record.affiliation ? <p className="mb-0">소속 : {record.affiliation}</p> :''}
								</div>
								<div className="col-md-2 form-group">
									<div className="btn-group pull-right">
										{record[this.props.pkKey] ?
											<button href="#" className="btn btn-outline-primary btn-sm insert" onClick={this.onEditSave}>수정</button>
											:
											<button href="#" className="btn btn-outline-primary btn-sm insert" onClick={this.onEditSave}>저장</button>
										}
										<button className="btn btn-outline-secondary btn-sm cancel" onClick={this.onCloseDelete}>닫기</button>
									</div>
								</div>
							</div>
						</div>
					</td>
			  </tr>
				}
      </>
    )
  }
}

export default Item;